import React from 'react';
import { Radio, Modal,message,Button } from 'antd';
const RadioGroup = Radio.Group;
class SelectResumeRole extends React.Component {
    state = {
        selectValue:null,
        visible:false
    }  
    show = () => {
        this.setState({visible:true});
    }

    hide = () =>{
        this.setState({selectValue:null,visible:false})
    }
    submitRole = () =>{
        const { selectValue } = this.state;
        if(!selectValue){
            message.warning('未选择选项');
        }else{
            sessionStorage.resumeRole = selectValue
            this.props.submit();
        }
    }

    render() {
        const { selectValue,visible } = this.state;
        return (
            <Modal
                    title="选择导出简历角色"
                    visible={visible}
                    onCancel={this.hide}
                    onOk={this.submitRole}
                    className="creat-modal EditPersonModal"
                    wrapClassName="vertical-center-modal"
                    maskClosable={false}
                    width={350}
                >
                    <div style={{ padding: '0 40px' }}>
                        <div style={{ padding: '20px 0',whiteSpace:'pre-wrap' }}>该用户有在临床项目上担任PM的工作经历，请选择导出简历的用户角色</div>
                        <RadioGroup onChange={(e)=>{this.setState({selectValue:e.target.value})}} value={selectValue}>
                            <Radio value={'CRC'}>CRC</Radio>
                            <Radio value={'PM'}>PM</Radio>
                        </RadioGroup>
                    </div>
                </Modal>

        );
    }
}

export default SelectResumeRole;



// WEBPACK FOOTER //
// ./src/components/common/curriculumVitae/SelectResumeRole.js